import axios from "axios";
import store from "../store";
import { clearLocalStorage } from "../commons/js/utils/clearLocalStorage";

const getAxiosInstance = (token, roleId) => {
  const instance = axios.create({
    baseURL: process.env.REACT_APP_BASEURL,
    headers: {
      "X-Access-Token": token ? token : localStorage.getItem("token"),
      "X-Role-Token": localStorage.getItem("role-token"),
      "Role-Id": roleId,
    },
  });

  instance.interceptors.response.use(
    (response) => {
      return response;
    },
    (error) => {
      // return error.response
      if (error.response.status === 401) {
        clearLocalStorage();
        // document.cookie = "isLoggedIn=true; expires="+new Date(0).toUTCString();
        store.dispatch({ type: "LOGOUT" });
      }
      throw error;
    }
  );

  return instance;
};

export default getAxiosInstance;
